var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_65141)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint0_radial_2136_65141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint1_radial_2136_65141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint2_radial_2136_65141)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint3_radial_2136_65141)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint4_radial_2136_65141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint5_radial_2136_65141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint6_radial_2136_65141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint7_radial_2136_65141)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C4.5 19.5 4.5 12 4.5 12H19.5C19.5 12 19.5 19.5 12 19.5Z",
    fill: "url(#paint8_radial_2136_65141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 13.125H6.375C5.75368 13.125 5.25 12.6213 5.25 12H18.75C18.75 12.6213 18.2463 13.125 17.625 13.125Z",
    fill: "url(#paint9_linear_2136_65141)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2136_65141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08566 10.7456C6.71517 10.9309 6.26467 10.7807 6.07943 10.4102C5.89419 10.0397 6.04435 9.58923 6.41484 9.40399L8.06971 8.57655H10.5002C10.4996 8.85995 10.3392 9.11884 10.0857 9.24563L7.08566 10.7456Z",
    fill: "url(#paint10_radial_2136_65141)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08566 6.40747C6.71517 6.22223 6.26467 6.3724 6.07943 6.74288C5.89419 7.11336 6.04435 7.56387 6.41484 7.74911L8.06971 8.57655H10.5002C10.4996 8.29315 10.3392 8.03425 10.0857 7.90747L7.08566 6.40747Z",
    fill: "url(#paint11_radial_2136_65141)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08566 10.4175C6.71517 10.6027 6.26467 10.4525 6.07943 10.082C5.89419 9.71156 6.04435 9.26105 6.41484 9.07581L8.06971 8.24837H10.5002C10.4996 8.53177 10.3392 8.79067 10.0857 8.91745L7.08566 10.4175Z",
    fill: "url(#paint12_linear_2136_65141)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08566 6.07934C6.71517 5.8941 6.26467 6.04427 6.07943 6.41475C5.89419 6.78524 6.04435 7.23574 6.41484 7.42098L8.06971 8.24842H10.5002C10.4996 7.96502 10.3392 7.70613 10.0857 7.57934L7.08566 6.07934Z",
    fill: "url(#paint13_linear_2136_65141)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2136_65141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4693 10.7456C16.8398 10.9309 17.2903 10.7807 17.4755 10.4102C17.6607 10.0397 17.5106 9.58923 17.1401 9.40399L15.4852 8.57655H13.0547C13.0553 8.85995 13.2157 9.11884 13.4693 9.24563L16.4693 10.7456Z",
    fill: "url(#paint14_radial_2136_65141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4693 6.40747C16.8398 6.22223 17.2903 6.3724 17.4755 6.74288C17.6607 7.11336 17.5106 7.56387 17.1401 7.74911L15.4852 8.57655H13.0547C13.0553 8.29315 13.2157 8.03425 13.4693 7.90747L16.4693 6.40747Z",
    fill: "url(#paint15_radial_2136_65141)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9029 10.4175C17.2734 10.6027 17.7239 10.4525 17.9091 10.082C18.0943 9.71156 17.9442 9.26105 17.5737 9.07581L15.9188 8.24837H13.4883C13.4889 8.53177 13.6493 8.79067 13.9029 8.91745L16.9029 10.4175Z",
    fill: "url(#paint16_linear_2136_65141)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9029 6.07934C17.2734 5.8941 17.7239 6.04427 17.9091 6.41475C18.0943 6.78524 17.9442 7.23574 17.5737 7.42098L15.9188 8.24842H13.4883C13.4889 7.96502 13.6493 7.70613 13.9029 7.57934L16.9029 6.07934Z",
    fill: "url(#paint17_linear_2136_65141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2136_65141",
    x: 5.5,
    y: 5.82812,
    width: 5.50024,
    height: 5.49684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2136_65141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2136_65141",
    x: 12.5547,
    y: 5.82812,
    width: 5.50024,
    height: 5.49684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2136_65141"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.125 6.75) rotate(132.839) scale(28.1275)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.125 6.75) rotate(131.878) scale(29.2115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 9.375) rotate(101.31) scale(13.3849 17.1435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5 10.5) rotate(135) scale(30.7591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12.75) rotate(77.692) scale(21.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.375 12.375) rotate(55.7131) scale(9.98515 7.23774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.375 13.5) rotate(9.86581) scale(8.75446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.125 11.25) rotate(43.9708) scale(44.2897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 21.1667) rotate(-90) scale(9.16667 18.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2136_65141",
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 13.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.33602 6.32812) rotate(110.225) scale(5.69488 7.44321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F5E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889024,
    stopColor: "#9F5E0F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.33602 6.32812) rotate(110.225) scale(5.69488 7.44321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F5E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889024,
    stopColor: "#9F5E0F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2136_65141",
    x1: 7.93384,
    y1: 11.0492,
    x2: 6.00008,
    y2: 7.04134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24955,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406361,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511203,
    stopColor: "#482641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2136_65141",
    x1: 6.64478,
    y1: 8.35389,
    x2: 8.43774,
    y2: 4.83827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24955,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406361,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511203,
    stopColor: "#482641"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1211 11.5781) rotate(-135.995) scale(10.0198 13.0959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9830A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801655,
    stopColor: "#F08B13",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2136_65141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1211 11.5781) rotate(-135.995) scale(10.0198 13.0959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9830A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801655,
    stopColor: "#F08B13",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2136_65141",
    x1: 16.0547,
    y1: 11.0492,
    x2: 17.9884,
    y2: 7.04134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24955,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406361,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511203,
    stopColor: "#482641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2136_65141",
    x1: 17.3438,
    y1: 8.35389,
    x2: 15.5508,
    y2: 4.83827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24955,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406361,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511203,
    stopColor: "#482641"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_65141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/funny.06fb384b.svg";
export { ForwardRef as ReactComponent };